import {NgModule} from '@angular/core';
import {COMPONENTS, SERVICES} from './index';
import {StoreModule} from '@ngrx/store';
import {CoreModule} from '../core/core.module';
import {qualityCheckReducer} from './store/quality-check.reducer';
import {SharedModule} from '../shared/shared.module';

@NgModule({
  imports: [
    CoreModule,
    SharedModule,
    StoreModule.forFeature('qualityCheck', qualityCheckReducer)
  ],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
  providers: [...SERVICES]
})
export class QualityCheckModule { }
